import { ReactNode } from 'react';
import {
  CustomAttributesEntity,
  getCustomAttributesConfig,
} from './custom-attributes-config/custom-attributes-config';
import { useCustomAttributesSidePanelData } from './hooks/use-custom-attributes-side-panel-data';
import { CustomAttributesSidePanelContext } from './side-panel-context';

interface CustomAttributesSidePanelProviderProps {
  entity: CustomAttributesEntity;
  entityId: string;
  partnerId: number | undefined;
  canEdit: boolean;
  children: ReactNode;
}

export const CustomAttributesSidePanelProvider = ({
  entity,
  entityId,
  partnerId,
  canEdit,
  children,
}: CustomAttributesSidePanelProviderProps) => {
  const { useStoredAttributes } = getCustomAttributesConfig(entity);
  const stored = useStoredAttributes(entityId);
  const value = useCustomAttributesSidePanelData({
    entity,
    entityId,
    partnerId,
    canEdit,
    stored,
  });

  return (
    <CustomAttributesSidePanelContext.Provider value={value}>
      {children}
    </CustomAttributesSidePanelContext.Provider>
  );
};
